import React from 'react';

import { DirectionIconPropsType } from './types';

export default ({ dir, index }: DirectionIconPropsType) => {
  return <i className={dir[index]}/>;
};
